// extracted by mini-css-extract-plugin
export default {"infoBoxContainer":"_5IHulthwTBoNYEOKQ1Cy5J"};